export const FRESHNESS_LABEL = "Computed live from this instance.";

export const DAY_MS = 24 * 60 * 60 * 1000;

// Shown when the account has no contracted percentile of its own to bill against.
export const FALLBACK_PERCENTILE = 95;

export const REQUESTED_PERCENTILES = [FALLBACK_PERCENTILE];
